const quickLinks = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "tel:+917569728595" },
]

const serviceLinks = [
  "Interior Designing Services",
  "Home Renovation Services",
  "Structural and Fixture Works",
]

const contactItems = [
  {
    label: "Call",
    value: "+91 7569728595",
    href: "tel:+917569728595",
  },
  {
    label: "Email",
    value: "vikramdwivedi78@gmail.com",
    href: "mailto:vikramdwivedi78@gmail.com",
  },
  {
    label: "Studio",
    value: "Employees Colony, Yapral, Hyderabad, Telangana 500087",
    href: "#contact",
  },
  {
    label: "Hours",
    value: "Mon - Sat / 8:00 AM - 6:00 PM",
    href: "#contact",
  },
]

const socials = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/designibv?igsh=Z3lmNnZheWpqdTNv",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
      </svg>
    ),
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/share/17kaSk7zYx/",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    label: "WhatsApp",
    href: "https://wa.me/917569728595",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </svg>
    ),
  },
]

export function Footer() {
  return (
    <footer className="border-t border-navy-light bg-navy text-white">
      <div className="px-6 pt-8 pb-10 md:px-10 lg:px-14">
        <div className="border border-white/12 bg-white/[0.04] p-6 backdrop-blur-sm md:p-8">
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <div className="max-w-2xl">
              <p className="text-[11px] font-light tracking-[0.35em] text-white/55 uppercase">
                Start Your Project
              </p>
              <h2 className="font-heading mt-3 text-3xl leading-tight text-white sm:text-4xl md:text-5xl">
                Let&apos;s shape a home that feels calm, tailored, and distinctly yours.
              </h2>
            </div>

            <a
              href="#booking"
              className="inline-flex w-fit items-center gap-3 border border-white bg-white px-6 py-3 text-[12px] font-light tracking-[0.22em] text-navy uppercase transition-all hover:bg-transparent hover:text-white"
            >
              Book Consultation
              <svg
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path d="M5 12h14m0 0-6-6m6 6-6 6" />
              </svg>
            </a>
          </div>
        </div>

        <div className="mt-10 grid gap-10 border-b border-white/10 pb-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="text-[11px] font-light tracking-[0.35em] text-white/45 uppercase">
              Design Inside by Vicky
            </p>
            <h3 className="font-heading mt-4 text-5xl leading-none text-white sm:text-6xl md:text-7xl">
              DESIGN
              <br />
              INSIDE
            </h3>
            <p className="mt-6 max-w-md text-[15px] leading-relaxed font-light text-white/68">
              Committed to delivering tailored, quality interior design solutions
              with integrity, craft, and a stronger sense of everyday living.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              {socials.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  className="flex h-11 w-11 items-center justify-center border border-white/16 bg-white/5 text-white/75 transition-all hover:border-white/40 hover:bg-white hover:text-navy"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-4">
            <div className="border border-white/10 bg-white/[0.03] p-6">
              <p className="text-[11px] font-light tracking-[0.3em] text-white/50 uppercase">
                Contact
              </p>
              <div className="mt-6 space-y-5">
                {contactItems.map((item) => (
                  <a
                    key={item.label}
                    href={item.href}
                    className="block border-b border-white/8 pb-4 last:border-b-0 last:pb-0"
                  >
                    <span className="block text-[10px] tracking-[0.28em] text-white/40 uppercase">
                      {item.label}
                    </span>
                    <span className="mt-2 block text-sm leading-relaxed font-light text-white/78 transition-colors hover:text-white">
                      {item.value}
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 lg:col-span-3 lg:grid-cols-1">
            <div>
              <p className="text-[11px] font-light tracking-[0.3em] text-white/50 uppercase">
                Explore
              </p>
              <ul className="mt-5 space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm font-light text-white/72 transition-colors hover:text-white"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <p className="text-[11px] font-light tracking-[0.3em] text-white/50 uppercase">
                Services
              </p>
              <ul className="mt-5 space-y-3">
                {serviceLinks.map((service) => (
                  <li key={service}>
                    <a
                      href="#services"
                      className="text-sm leading-relaxed font-light text-white/72 transition-colors hover:text-white"
                    >
                      {service}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-3 pt-6 text-[11px] tracking-[0.2em] text-white/35 uppercase md:flex-row md:items-center md:justify-between">
          <p>&copy; 2025 Design Inside by Vicky</p>
          <p>Interior Design / Renovation / Turnkey Execution</p>
        </div>
      </div>
    </footer>
  )
}
